export default __webpack_public_path__ + "static/media/img_area_70.d7164742.svg";